import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './rateCards.intl.json';

export const useRateCardsIntl = () => useIntlModule(messages);
